import React, {createContext} from 'react';
import {HashRouter as Router, Switch, Route} from 'react-router-dom';
import {ConfigProvider, Toast} from 'zarm';
import {WithLazyLoad, Layout} from '@wap/components';
import request from '@utils/request';
import {Provider} from 'react-redux';
import store from './store/index';
import './global.less';
import {getQueryString} from '@utils/index';
// 媒体demo
import MediaDemo from '@wap/components/Media';
import Demo from '@wap/components/demo';

export const NavContext = createContext();

request.message = function (content) {
  Toast.show({
    content,
    mask: true,
    stayTime: 1000,
  });
};

// 懒加载引入
const UserAgreement = React.lazy(() => import(`@wap/UserAgreement`)); // 相关条款页面
const EditName = React.lazy(() => import(`@wap/Mine/EditUserMessage/EditName`)); // 修改姓名
const EditSignature = React.lazy(() =>
  import(`@wap/Mine/EditUserMessage/EditSignature`)
); // 修改个性签名

const Authorize = React.lazy(() => import(`@wap/Mine/Authorize/index`)); // 我的-授权列表
const AuthorizeDetail = React.lazy(() => import(`@wap/Mine/Authorize/detail`)); // 我的-授权详情
const Consent = React.lazy(() => import('@wap/PatientWap/Consent')); // 知情同意书签署
const ConsentPreview = React.lazy(() =>
  import('@wap/PatientWap/Consent/preview.jsx')
); // 知情同意书预览

const CheckConsent = React.lazy(() =>
  import('@wap/PatientWap/Consent/checkConsent.jsx')
); // 知情同意书下载预览中间页面

const BuildArchive = React.lazy(() =>
  import('@wap/PatientWap/BuildArchive/index')
); // 建档

const ReceptionDetail = React.lazy(() => import('@wap/WorkStation/index')); // 工作站详情
const CollectDetail = React.lazy(() => import('@wap/CollectDetail/index')); // 收藏笔记详情

const AssistanceDetail = React.lazy(() =>
  import('@wap/AssistanceDetail/index')
); // 医辅的详情

const HistoryDetail = React.lazy(() => import('@wap/CollectDetail/index')); // 历史记录详情

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initial: false, // 页面是否初始化完成，默认false
    };
  }

  componentDidMount() {
    this.handleInitial();
  }

  /**
   * 初始化方法
   */
  handleInitial = () => {
    if (sessionStorage.tenantId !== undefined) {
      this.setState({
        initial: true,
      });
      return;
    }
    // const token = '6b91512e4c454d0bb31f51fbb0fe34b68'
    // const accouserId = '543314042572378600'
    // const tenantId = '540347589451715066'
    // const userId = '1231231241'
    // 启动项参数
    const token = getQueryString('token');
    const tenantId = getQueryString('tenantId');
    const accouserId = getQueryString('accoId');
    const userId = getQueryString('userId');
    // 是不是pc端预览
    const pcPreview = getQueryString('pcPreview');
    const useragent = getQueryString('User-Agent');
    const os = getQueryString('os');
    const device = getQueryString('device');

    if (`${tenantId}` && pcPreview !== 1) {
      sessionStorage.token = token || '';
      sessionStorage.tenantId = tenantId || '0'; // 请求头的tenantId的值，app端是0，患者端的是从url里读
      sessionStorage.accouserId = accouserId || '';
      sessionStorage.userId = userId || '';
      sessionStorage.useragent = useragent || '';
      sessionStorage.os = os || '';
      sessionStorage.device = device || '';
      // sessionStorage.accoId = accoId || '';
      this.setState({
        initial: true,
      });
    }
  };

  setNavBar = (optionals) => {
    document.title = optionals;
  };

  render() {
    const {initial} = this.state;

    return (
      <>
        {initial && (
          <NavContext.Provider value={{setNavBar: this.setNavBar}}>
            <Provider store={store}>
              <Router basename="/">
                <Switch>
                  <ConfigProvider primaryColor="#00A185">
                    <Layout>
                      <Route
                        exact
                        path="/agreement/:type"
                        component={WithLazyLoad(UserAgreement)}
                      />

                      <Route
                        exact
                        path="/mine/editname"
                        component={WithLazyLoad(EditName)}
                      />
                      <Route
                        exact
                        path="/mine/authorize"
                        component={WithLazyLoad(Authorize)}
                      />
                      <Route
                        exact
                        path="/mine/authorize/detail/:id/:tenaId"
                        component={WithLazyLoad(AuthorizeDetail)}
                      />
                      <Route
                        exact
                        path="/mine/editsignature"
                        component={WithLazyLoad(EditSignature)}
                      />

                      {/* 患者端 */}
                      <Route
                        exact
                        path="/patientwap/consent/detail/:id"
                        component={WithLazyLoad(Consent)}
                      />
                      <Route
                        exact
                        path="/patientwap/consent/preivew/:id/:tenaId"
                        component={WithLazyLoad(ConsentPreview)}
                      />
                      <Route
                        exact
                        path="/patientwap/buildarchive"
                        component={WithLazyLoad(BuildArchive)}
                      />
                      <Route
                        exact
                        path="/patientwap/consent/checkconsent/:id/:tenaId"
                        component={WithLazyLoad(CheckConsent)}
                      />
                      <Route
                        exact
                        path="/reception/detail/:patientId/:treaId/:tenantId/:processId/:roleType/:isPersonal/:patientType"
                        component={WithLazyLoad(ReceptionDetail)}
                      />
                      <Route
                        exact
                        path="/assistance/detail/:patiId/:nodeId/:attendLink/:tenantId"
                        component={WithLazyLoad(AssistanceDetail)}
                      />
                      <Route
                        exact
                        path="/collect/detail/:patientId/:tenantId"
                        component={WithLazyLoad(CollectDetail)}
                      />

                      <Route
                        exact
                        path="/history/detail/:patientId/:tenantId/:type"
                        component={WithLazyLoad(HistoryDetail)}
                      />

                      {/* 各种组件例子 */}
                      <Route exact path="/media" component={MediaDemo} />
                      <Route exact path="/tab" component={Demo} />
                    </Layout>
                  </ConfigProvider>
                </Switch>
              </Router>
            </Provider>
          </NavContext.Provider>
        )}
      </>
    );
  }
}

export default App;
